let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2qYp0")).then(() => parcelRequire('dqAEN'));